import { useLocation } from '@do/seashell/navigation';
import useSession from '../hooks/use-session';
import { useSift } from '@do/seashell';

export const SiftScript = ({
  sessionId,
  path
}: {
  sessionId?: string;
  path: string;
}): null => {
  useSift({
    sessionId: sessionId,
    path
  });

  return null;
};

export const SiftScriptWrapper = () => {
  const { session_id: sessionId } = useSession();
  const location = useLocation();

  return <SiftScript path={location.pathname} sessionId={sessionId!} />;
};
